<template>
  <div v-if="item" class="flex flex-row gap-x-4 p-4" :class="color === 'white' ? 'bg-white' : 'bg-neutral-50'">
    <dt class="basis-2/6 truncate text-xs font-medium capitalize text-neutral-500">
      <slot name="name">
        {{ row.term }}
      </slot>
    </dt>
    <dd class="basis-4/6 text-xs">
      <div class="flex flex-row justify-between gap-1">
        <div class="text-gray-900">
          <slot v-if="isGenericSlot" name="value">
            {{ get(item, row.detailField) }}
          </slot>
          <slot v-else :name="row.name">
            {{ get(item, row.detailField) }}
          </slot>
        </div>
        <InfuseCopy v-if="copyable" v-slot="scope" @click.stop="">
          <!-- @click.stop: stop bubbling up -->
          <span
            class="mr-4 cursor-pointer whitespace-nowrap font-semibold text-primary-600 hover:text-primary-500 md:m-20"
            @click="scope.copy(get(item, row.detailField))"
          >
            {{ t('action.copy') }}
            <font-awesome-icon :icon="['far', 'copy']" />
          </span>
        </InfuseCopy>
      </div>
    </dd>
  </div>
</template>

<script lang="ts" setup>
import { UiDescriptionListRow } from '@infuse/ui/domain';
import { getFieldFromPath } from '@infuse/utils';
import { useI18n } from 'vue-i18n';
import { InfuseCopy } from '../index';

interface Props {
  row: UiDescriptionListRow;
  item: never;
  color?: 'white' | 'grey';
  copyable?: boolean;
  isGenericSlot?: boolean;
}

withDefaults(defineProps<Props>(), {
  color: 'white',
  copyable: false,
  isGenericSlot: false
});

const { t } = useI18n();

const get = (obj: unknown, path: any, defValue?: unknown) => getFieldFromPath(obj, path, defValue)?.toString();
</script>

<i18n>
{
  "en": {
    "action": {
      "copy": "Copy"
    }
  },
  "nl": {
    "action": {
      "copy": "Kopieer"
    }
  }
}
</i18n>
